import { stageIdsForAcceptanceStatuses } from './tabs/Flats/components/TableView/config/room';

const sortFlats = (left, right) => {
  if (left.porch === undefined) return 1;
  if (right.porch === undefined) return -1;
  return left.porch - right.porch;
};

const formEntrancesForGrid = (flat, entranceIndexes, entrances) => {
  const porchCount = new Set(flat.cells.map((cell) => cell.porch));

  porchCount.forEach((porch) => {
    const cells = flat.cells.filter((cell) => cell.porch === porch);
    const entranceIndex = entranceIndexes.get(porch);

    if (entranceIndex === undefined) {
      entranceIndexes.set(porch, porch - 1);

      entrances[porch - 1] = {
        name: `${porch}-й подъезд`,
        flats: [
          {
            ...flat,
            cells,
            size: porchCount.size === 1 ? flat.size : cells.length,
          },
        ],
      };
    } else {
      entrances[entranceIndex].flats.push({
        ...flat,
        cells,
        size: porchCount.size === 1 ? flat.size : cells.length,
      });
    }
  });
};

const addTableItem = ({ obj, key, item }) => {
  if (!key) return;

  obj[key] = obj[key] || new Set();
  obj[key].add(item);
};

const processTableKeys = ({ tableData, keys, targetKey, item }) => {
  const targetData = tableData.get(targetKey) || {};
  keys.forEach((key) => addTableItem({ obj: targetData, key, item }));
  tableData.set(targetKey, targetData);
};

const createTableFilter = ({
  filterNames,
  value,
  filter,
  key,
  filterNamesToId,
}) => {
  filterNames.forEach((name) => {
    const data = value[name];

    if (data) {
      const items = filter.get(key) || [];
      items.push({ name, count: data.size, id: filterNamesToId.get(name) });
      filter.set(key, items);
    }
  });
};

const sortTableFilterByCount = (filter) => {
  filter.forEach((items) => {
    items.sort((a, b) => b.count - a.count);
  });
};

const NO_DATA_ACCEPTANCE_VALUE = '__NO_DATA_ACCEPTANCE__';
const NO_DATA_SALE_VALUE = '__NO_DATA_SALE__';
const emptyArr = [];

const formTableData = ({
  item,
  typeFiletrNames,
  stageFilterNames,
  stepsFilterNames,
  acceptanceStatusFilterNames,
  salesFilterNames,
  tableData,
  entrances,
  filterNamesToId,
}) => {
  const { address, addressLifeCycle, porch } = item;
  const { typeId, typeName } = address || {};
  const { id: stageId, name: stageName } =
    addressLifeCycle?.stageAddressLifeCycle || {};
  const { id: stepId, name: stepName } =
    addressLifeCycle?.stepAddressLifeCycle || {};
  const { id: acceptanceStatusId, name: acceptanceStatusName } =
    addressLifeCycle?.acceptanceStatusAddressLifeCycle || {};
  const { id: salesId, name: salesName } =
    addressLifeCycle?.saleAddressLifeCycle || {};

  const porchKey = porch ? `${porch}-й подъезд` : 'Помещения';

  const hasAcceptanceData =
    stageIdsForAcceptanceStatuses.has(stageId) && Boolean(acceptanceStatusName);

  const hasSaleData = Boolean(salesName);
  const keys = [
    'Все',
    typeName,
    stageName,
    stepName,
    hasAcceptanceData ? acceptanceStatusName : NO_DATA_ACCEPTANCE_VALUE,
    hasSaleData ? salesName : NO_DATA_SALE_VALUE,
  ];

  //собрать имена фильтров
  [
    { value: typeName, id: typeId, names: typeFiletrNames },
    { value: stageName, id: stageId, names: stageFilterNames },
    { value: stepName, id: stepId, names: stepsFilterNames },
    {
      value: acceptanceStatusName,
      id: acceptanceStatusId,
      names: acceptanceStatusFilterNames,
    },
    { value: salesId, id: salesName, names: salesFilterNames },
  ].forEach(({ value, id, names }) => {
    if (value) {
      filterNamesToId.set(value, id);
      names.add(value);
    }
  });

  // добавить данные в группировку
  ['Все', porchKey].forEach((targetKey) => {
    processTableKeys({ tableData, keys, targetKey, item });
  });

  // добавить подъезд
  if (!entrances[porchKey]) {
    entrances[porchKey] = { name: porchKey };
  }
};

export const getPreparedFlatsGrid = (flats) => {
  // grid
  const entrancesForGrid = [];
  const entranceIndexesForGrid = new Map();

  // table
  const tableEntrances = { all: { name: 'Все' } };
  const tableData = new Map();
  const typeFiletrNames = new Set();
  const stageFilterNames = new Set();
  const stepsFilterNames = new Set();
  const acceptanceStatusFilterNames = new Set();
  const salesFilterNames = new Set();
  const filterNamesToId = new Map();

  flats
    .slice()
    .sort(sortFlats)
    .forEach((flat) => {
      formEntrancesForGrid(flat, entranceIndexesForGrid, entrancesForGrid);

      formTableData({
        item: flat,
        typeFiletrNames,
        stageFilterNames,
        stepsFilterNames,
        acceptanceStatusFilterNames,
        salesFilterNames,
        tableData,
        entrances: tableEntrances,
        filterNamesToId,
      });
    });

  tableData.forEach((value) => {
    value[NO_DATA_ACCEPTANCE_VALUE] =
      value[NO_DATA_ACCEPTANCE_VALUE] || new Set();
    value[NO_DATA_SALE_VALUE] = value[NO_DATA_SALE_VALUE] || new Set();
  });

  if (tableData.size === 2) {
    const keyToDelete = [...tableData.keys()].find((key) => key !== 'Все');
    tableData.delete(keyToDelete);
  }

  // создаьть фильтры
  const typesFilter = new Map();
  const stagesFilter = new Map();
  const acceptanceStatusesFilter = new Map();
  const stepsFilter = new Map();
  const salesFilter = new Map();

  tableData.forEach((value, key) => {
    [
      { filterNames: typeFiletrNames, filter: typesFilter },
      { filterNames: stageFilterNames, filter: stagesFilter },
      { filterNames: stepsFilterNames, filter: stepsFilter },
      {
        filterNames: acceptanceStatusFilterNames,
        filter: acceptanceStatusesFilter,
      },
      {
        filterNames: salesFilterNames,
        filter: salesFilter,
      },
    ].forEach(({ filterNames, filter }) => {
      createTableFilter({ filterNames, value, filter, key, filterNamesToId });
      sortTableFilterByCount(filter);
    });
  });

  return {
    flatsGridData: entrancesForGrid,
    flatsTableData: {
      entrances: tableData.size > 1 ? Object.values(tableEntrances) : emptyArr,
      data: tableData,
      filters: {
        types: typesFilter,
        stages: stagesFilter,
        acceptanceStatuses: acceptanceStatusesFilter,
        steps: stepsFilter,
        sales: salesFilter,
      },
    },
  };
};
